/**
 * The anchors this page links to itself by.
 *
 * `Common` (`components/portal/common.ts`) is ARIA plus an `id`, which is the whole
 * of what a primitive will take from a page — so an in-page link needs the id in one
 * place rather than typed at both ends.
 */

/** §3 — the under-scoped card. The hero's third tile points at it. */
export const UNDER_SCOPED_ID = 'under-scoped'
